// @flow

import compact from 'lodash/compact';
import sortBy from 'lodash/fp/sortBy';
import filter from 'lodash/fp/filter';
import compose from 'lodash/fp/compose';
import isArray from 'lodash/isArray';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import { Map } from 'immutable';
import React from 'react';
import moment from 'moment';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import type { StageResult } from 'type/type';
import { formatedDurationByMilliseconds } from 'services/format/formatDuration';

import NoRecord from 'components/NoRecord/NoRecord';
import SportStageResult from './SportStageResult/SportStageResult';
import TransitionStageResult from './TransitionStageResult/TransitionStageResult';
import { getParticipantSummaryResults } from '../duck/selector';
import './SummaryResults.scss';

type Props = {
  results: StageResult[],
  isLive: boolean
}
const filterStageResult = filter(
  result => result.type !== 'TRANSITION',
);
const filterTransitionResult = filter(
  result => result.type === 'TRANSITION',
);
const getStageResult = compose(
  sortBy('sequence'),
  filterStageResult,
);
const getTransitionResult = compose(
  sortBy('sequence'),
  filterTransitionResult,
);

export const SummaryResults = ({ results, isLive }: Props) => {
  const hasResult = !isLive && (isArray(results)
    && results.some(r => r && r.result && (r.result.chipTimeResult || r.result.gunTimeResult)));

  let sportStageResults = getStageResult(results);
  let transitionStageResults = getTransitionResult(results);

  let sortedResults = [];
  for (let i = 0; i < sportStageResults.length; i++) {
    sortedResults = compact(sortedResults.concat(sportStageResults[i]).concat(transitionStageResults[i]));
  }

  let totalTime = 0;
  let calculateFlag = true;
  sortedResults = sortedResults.map((sortedResult) => {
    if (sortedResult.result && sortedResult.result.splitTime && calculateFlag) {
      totalTime += moment.duration(sortedResult.result.splitTime);

      return {
        ...sortedResult,
        result: {
          ...sortedResult.result,
          totalTime: formatedDurationByMilliseconds(totalTime),
        },
      };
    }

    calculateFlag = false;

    return sortedResult;
  });

  sportStageResults = filterStageResult(sortedResults);
  transitionStageResults = filterTransitionResult(sortedResults);

  return hasResult ? (
    <div className="participant-summary-results">
      <div className="participant-summary-results__sport-stage">
        <ul className="summary-result-list">
          {
            sportStageResults.map(r => (
              <li key={r.id}>
                <SportStageResult
                  type={r.type}
                  name={r.name}
                  result={r.result}
                  rank={r.rank} />
              </li>))
          }
        </ul>
      </div>
      {
        transitionStageResults.length > 0 && <div className="participant-summary-results__transition-detail--title">
          <L10nMessage id="page.participant.summary.transition.detail" />
        </div>
      }
      <div className="participant-summary-results__transition-stage">
        <ul className="transition-result-list">
          {
            transitionStageResults.map((r, i) => (
              <li key={r.id}>
                <TransitionStageResult
                  index={i}
                  result={r.result} />
              </li>))
          }
        </ul>
      </div>
    </div>
  ) : (
    <NoRecord />
  );
};

const mapState = (state: Map<*, *>) => ({
  results: getParticipantSummaryResults(state),
});

export default connect(mapState)(SummaryResults);
